<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ data.title }}</h3>
    </div>
  </div>
  <div class="form">
    <div class="card-body">
      <div class="form-group row" [formGroup]="form">
        <div class="col-lg-12">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>{{ labelText }}</mat-label>
            <input matInput formControlName="name" required />
            <mat-error *ngIf="name.invalid">{{ getErrorMessage(name) }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            color="secondary"
            mat-button
            (click)="onNoClick()"
          >
            Cancel</button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            mat-button
            (click)="onYesClick()"
            color="primary"
            cdkFocusInitial
          >
            {{ data.btnTitle }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
